export const colors = {
    black: {
        normal: '#000',
    },
    white: {
        normal: '#fff',
    },
    grey: {
        tab: '#adb7c5',
        lighter: '#6e7b8b', //In the SCSS variables is called: grey-light
        light: '#47515d', //In the SCSS variables is called: grey-hover
        normal: '#2f353d',
        medium: '#23292f',
        dark: '#161b21',
    },
    orange: {
        light: '#fd9d20',
        normal: '#ff7d08',
        dark: '#ba6108',
    },
    yellow: {
        light: '#fff38a',
        normal: '#ffe400',
        dark: '#a59500',
    },
    blue: {
        light: '#46adff',
        normal: '#0d89eb',
        dark: '#076fc1',
        darker: '#1a3b5b',
    },
    red: {
        light: '#ff5745',
        normal: '#f92b00',
        dark: '#b21100',
    },
    green: {
        light: '#32db86',
        normal: '#28a968',
        dark: '#1b8750',
        darker: '#00663f',
        darkest: '#003520',
    },
    purple: {
        light: '#ec80ff',
        normal: '#bd00df',
        dark: '#6b007e',
    },
    meta: {
        light: '#fff',
        normal: '#d8d8d8',
        dark: '#bfbfbf',
    },
    social: {
        facebook: '#3b5998',
        twitter: '#1da1f2',
        youtube: '#cd201f',
        twitch: '#6441a5',
        line: '#00c300',
    },
    text: {
        normal: '#ededed',
        textLight: '#ededed',
        textStrong: '#ededed',
        textSelection: '#0d89eb',
    },
    primary: '#ff7d08',
    bodyBackground: '#2f353d',
    background: '#2f353d',
    linkVisited: '#ff7d08',
    linkHover: '#fd9d20',
    linkInvert: '#ff7d08',
};

export const sizes = {

}